// extracted by mini-css-extract-plugin
export default {"center":"_3Pya","button":"_3twq"};